import logo from './logo.svg';
import './App.css';
import React, { useState } from 'react';
import { parse, isBefore, addDays, startOfDay } from 'date-fns';
import { areaPrices } from './AreaPrices'; // AreaPrices.jsからのインポート
import "../node_modules/uikit/dist/css/uikit.min.css"
import "../node_modules/uikit/dist/js/uikit.min.js"

function App() {
  const [isFirstTime, setIsFirstTime] = useState(null);
  const [people, setPeople] = useState('');
  const [hours, setHours] = useState('');
  const [area, setArea] = useState('');
  const [time, setTime] = useState('');
  const [femaleInstructor, setFemaleInstructor] = useState(null);
  const [date, setDate] = useState('');  // 利用日のステート

  const prices = {
    true: 15000,
    false: 0
  };

  const initialFee = isFirstTime ? prices[true] * Number(people) : prices[false] * Number(people);
  const femaleInstructorFee = femaleInstructor ? 3000 : 0;
  const outcallFee = 5000;
  const taxRate = 0.10;

  const calculateNightFee = (time) => {
    const userInputTime = parse(time, 'HH:mm', new Date());
    const am5 = parse("05:00", 'HH:mm', new Date());
    const am8 = parse("08:00", 'HH:mm', new Date());
    const pm10 = parse("22:00", 'HH:mm', new Date());
    const midnight = startOfDay(addDays(new Date(), 1));

    if (userInputTime >= pm10 && userInputTime < midnight) {
      return 3500;
    } else if (userInputTime >= midnight && userInputTime < am5) {
      return 5000;
    } else if (userInputTime >= am5 && userInputTime < am8) {
      return 3500;
    }
    return 0;
  };

  const calculatePrice = (people, hours) => {
    let rate = 0;
    if (people === 1) {
      rate = hours > 1 ? 5000 : 7000;
    } else if (people >= 2 && people <= 4) {
      rate = hours > 1 ? 4000 : 6000;
    } else if (people >= 5) {
      rate = hours > 1 ? 3500 : 5000;
    }
    return rate * people * hours;
  }

  const isSundayOrHoliday = (inputDate) => {
    console.log("inputDate : " + inputDate)
    if (!inputDate) return false;

    const dateObj = new Date(inputDate);
    if (dateObj.getDay() === 0) {
      return true;
    }

    const fixedHolidays = [
      "2024-12-23",  // 天皇誕生日
      "2025-01-01", // 元日
      "2025-01-13", // 成人の日
      "2025-02-11", // 建国記念の日
      "2025-02-23", // 天皇誕生日
      "2025-02-24", // 休日
      "2025-03-20", // 春分の日
      "2025-04-29", // 昭和の日
      "2025-05-03", // 憲法記念日
      "2025-05-04", // みどりの日
      "2025-05-05", // こどもの日
      "2025-05-06", // 休日
      "2025-07-21", // 海の日
      "2025-08-11", // 山の日
      "2025-09-15", // 敬老の日
      "2025-09-23", // 秋分の日
      "2025-10-13", // スポーツの日
      "2025-11-03", // 文化の日
      "2025-11-23", // 勤労感謝の日
      "2025-11-24"  // 休日   
    ];
    // const monthDay = dateObj.toISOString().slice(5, 10);

    console.log("fixedHolidays : ", fixedHolidays)
    console.log("inputDate : ", inputDate)
    console.log("fixedHolidays.includes(inputDate) : ", fixedHolidays.includes(inputDate))
    return fixedHolidays.includes(inputDate);
  }

  const nightFee = calculateNightFee(time);
  const holidayFee = isSundayOrHoliday(date) ? 2000 * Number(hours) : 0;
  const total = isFirstTime !== null && area in areaPrices
    ? calculatePrice(Number(people), Number(hours)) + initialFee + outcallFee + (areaPrices[area] || 0) + nightFee + femaleInstructorFee + holidayFee
    : null;
  const totalWithTax = total ? total * (1 + taxRate) : null;


  return (
    <div class="uk-container uk-container-small">
      <form class="uk-form-horizontal uk-margin-large">
        <div class="uk-margin">
          <div class="uk-form-label">利用ははじめて？</div>
          <div class="uk-form-controls">
            <label><input type="radio" class="uk-radio" value="true" checked={isFirstTime === true} onChange={() => setIsFirstTime(true)} />
              はい</label>
            <label><input type="radio" class="uk-radio" value="false" checked={isFirstTime === false} onChange={() => setIsFirstTime(false)} />
              いいえ</label>
          </div>
        </div>
        <div class="uk-margin">
          <label class="uk-form-label" for="form-horizontal-text">利用人数:</label>
          <div class="uk-form-controls">
            <input type="number" class="uk-input uk-form-width-medium" value={people} onChange={e => setPeople(e.target.value)} min={0} />
          </div>
        </div>
        <div class="uk-margin">
          <label class="uk-form-label" for="form-horizontal-text">利用時間:</label>
          <input type="number" class="uk-input uk-form-width-medium" value={hours} onChange={e => setHours(e.target.value)} min={0} />
        </div>
        <div class="uk-margin">
          <label class="uk-form-label" for="form-horizontal-text">利用時間帯:</label>
          <input type="time" class="uk-input uk-form-width-medium" value={time} onChange={e => {
            console.log("Time : " + e.target.value)
            setTime(e.target.value)
          }} />
        </div>
        <div class="uk-margin">
          <label class="uk-form-label" for="form-horizontal-text">エリア（市区町村を入力してください）:</label>
          <input type="text" class="uk-input uk-form-width-medium" value={area} onChange={e => setArea(e.target.value)} />

        </div>
        <div class="uk-margin">
          <label class="uk-form-label" for="form-horizontal-text">利用日:</label>
          <input type="date" class="uk-input uk-form-width-medium" value={date} onChange={e => setDate(e.target.value)} />

        </div>
        <div class="uk-margin">
          <div class="uk-form-label">女性インストラクター希望：</div>
          <div class="uk-form-controls">
            <label><input type="radio" class="uk-radio" value="true" checked={femaleInstructor === true} onChange={() => setFemaleInstructor(true)} />
              はい</label>

            <label><input type="radio" class="uk-radio" value="false" checked={femaleInstructor === false} onChange={() => setFemaleInstructor(false)} />
              いいえ</label>
          </div>
        </div>

        {isFirstTime !== null && !area && (
          <div style={{ color: 'red' }}>エリアを入力してください。</div>
        )}

      </form>

      {isFirstTime !== null && (
        <table class="uk-table uk-table-middle uk-table-striped">
          <tbody>
            <tr><td>初期費用:　</td><td class="uk-text-right"><span class="uk-text-bold">{initialFee}</span>円</td></tr>
            <tr><td>出張基本料金:　</td><td class="uk-text-right"><span class="uk-text-bold">{outcallFee}</span>円</td></tr>
            <tr><td>レッスン料:　</td><td class="uk-text-right"><span class="uk-text-bold">{calculatePrice(Number(people), Number(hours))}</span>円</td></tr>
            <tr><td>エリア料金:　</td><td class="uk-text-right"><span class="uk-text-bold">{areaPrices[area] || 0}</span>円</td></tr>
            <tr><td>夜間料金:　</td><td class="uk-text-right"><span class="uk-text-bold">{nightFee}</span>円</td></tr>
            <tr><td>女性インストラクター料金:　</td><td class="uk-text-right"><span class="uk-text-bold">{femaleInstructorFee}</span>円</td></tr>
            <tr><td>日曜・祝日料金:　</td><td class="uk-text-right"><span class="uk-text-bold">{holidayFee}</span>円</td></tr>
            <tr><td class="uk-text-bold">合計:　</td><td class="uk-text-right"><span class="uk-text-bold">{total}</span>円</td></tr>
            <tr><td class="uk-text-bold">税込み合計:　</td><td class="uk-text-right"><span class="uk-text-bold">{totalWithTax ? Math.floor(totalWithTax) : '計算中'}</span>円</td></tr>
          </tbody>
        </table>
      )}
      {isFirstTime !== null && area && !(area in areaPrices) && (
        <div style={{ color: 'red' }}>
          出張対象外のエリアです。
          <p>遠隔サポートをご利用いただけますので、詳細についてお問い合わせください。</p>
        </div>
      )}

    </div>
  );
}

export default App;
